export const userFormTabs = { GENERAL: "General", SECURITY: "Security Roles" };
